import Reveal from "./Reveal";

export default function BookingPortal() {
  return (
    <section
      id="book-portal"
      data-testid="booking-portal-section"
      className="relative bg-[#050505] pt-10 pb-24 lg:pt-14 lg:pb-32 scroll-mt-24"
    >
      <div className="mx-auto max-w-[1100px] px-6 lg:px-10">
        <div className="mb-10 lg:mb-14 max-w-3xl">
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#169ED9]">
              / Book a free assessment
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Pick A Time That Suits You.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-white/55 leading-relaxed max-w-2xl">
              Choose a slot and our team will confirm your free onsite assessment.
              Prefer to leave your details instead? Scroll down.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div
            data-testid="booking-portal-frame-wrap"
            className="relative overflow-hidden rounded-2xl border border-white/10 bg-white shadow-[0_30px_120px_-30px_rgba(22,158,217,0.35)]"
          >
            <iframe
              src="https://plumbing-electrical-booking-widget.vercel.app/embed"
              title="Book a plumber or electrician"
              width="100%"
              style={{ minHeight: "720px", border: 0, width: "100%", display: "block" }}
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              data-testid="booking-portal-iframe"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
